<template>
  <section class="deals-section">
    <div class="container">
      <h2 class="deals-title">Deals of the week</h2>

      <div class="deals-divider">
        <div class="line"></div>
        <div class="pagination-dots">
          <span
            class="dot"
            v-for="index in Math.ceil(dealsList.length / 2)"
            :key="index - 1"
            :class="{ active: index - 1 === 0 }"
            data-bs-target="#dealsCarousel"
            :data-bs-slide-to="index - 1"
          ></span>
        </div>
      </div>

      <div class="deals-slider">
        <!-- Bootstrap Carousel -->
        <div
          id="dealsCarousel"
          class="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="2000"
        >
          <div class="carousel-inner">
            <div
              class="carousel-item"
              v-for="(slideDeals, index) in groupedDeals"
              :key="index"
              :class="{ active: index === 0 }"
            >
              <div class="row">
                <div class="col-md-6" v-for="deal in slideDeals" :key="deal.id">
                  <div class="deal-card">
                    <router-link
                      :to="'/book/' + deal.book._id"
                      style="text-decoration: none"
                    >
                      <img
                        :src="
                          deal.book?.images[0] ?
                          `${BASE_IMAGE_PREFIX}/${deal.book.images[0]}` :
                          'https://libreture.com/static/images/book-placeholder.png'
                        "
                        :alt="deal.book.title"
                        class="deal-image"
                      />
                    </router-link>
                    <!-- <div class="deal-image">
                      <img :src="deal.book.imageUrl" :alt="deal.title" />
                    </div> -->
                    <div class="deal-content">
                      <router-link
                        :to="'/book/' + deal.book._id"
                        style="text-decoration: none"
                      >
                        <h3 class="deal-title">{{ deal.book.title }}</h3>
                      </router-link>
                      <router-link
                        v-if="deal.book.productCategory !== 'stationary'"
                        :to="
                          '/search/?a=' + deal.book.author.replace(/ /g, '_')
                        "
                        style="text-decoration: none"
                      >
                        <div class="deal-author">{{ deal.book.author }}</div>
                      </router-link>
                      <div class="deal-price" v-if="deal.book.minVariant">
                        <span v-if="deal.book.minVariant.salePrice">
                          <span class="text-decoration-line-through text-muted me-1">
                            ৳ {{ deal.book.minVariant.price }}
                          </span>
                          <span>৳ {{ deal.book.minVariant.salePrice }}</span>
                        </span>
                        <span v-else>৳ {{ deal.book.minVariant.price }}</span>
                      </div>
                      <div
                        class="card-footer p-0 pb-4 pt-2 border-top-0 bg-transparent"
                      >
                        <div class="text-left d-flex gap-2 flex-wrap">
                          <span
                            class="btn btn-outline-dark d-inline-flex align-items-center text-uppercase"
                            @click="addToCart(deal.book)"
                            style="font-size: 10px"
                          >
                            <i class="bi bi-cart3 me-1"></i> Add to cart
                          </span>
                          <span
                            class="btn btn-outline-dark d-inline-flex align-items-center justify-content-center text-uppercase"
                            @click="addToWishlist(deal.book)"
                            style="font-size: 10px"
                          >
                            <i class="bi bi-suit-heart"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { BASE_IMAGE_PREFIX } from '@/globals';
import { analytics } from '@/services/analytics';

export default {
  name: "DealsSlider",
  props: {
    dealsList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      BASE_IMAGE_PREFIX,
    }
  },
  computed: {
    groupedDeals() {
      const isMobileOrTablet = window.innerWidth < 768;
      const itemsPerGroup = isMobileOrTablet ? 1 : 2;

      const grouped = [];

      for (let i = 0; i < this.dealsList.length; i += itemsPerGroup) {
        grouped.push(this.dealsList.slice(i, i + itemsPerGroup));
      }

      return grouped;
    },
  },
  methods: {
    addToCart(book) {
      if (!book.minVariant) return;

      const cartItem = {
        product: book,
        quantity: 1,
        variant: book.minVariant
      };

      this.$store.dispatch("addToCart", cartItem);

      this.$root.showToast({
        message: "Item added to cart!",
        status: "success",
        duration: 3000,
      });

      analytics.addToCart(book,
        book.minVariant.salePrice || book.minVariant.price, 1)
    },
    addToWishlist(book) {
      const wishedItem = {
        ...book,
        quantity: 1,
        variant: book.minVariant
      };
      this.$store.dispatch("addToWishlist", wishedItem);
      this.$root.showToast({
        message: "Item added to wishlist!",
        status: "success",
        duration: 3000,
      });
      analytics.addToWishlist(book,
        book.minVariant.salePrice || book.minVariant.price, 1)
    },
  },
};
</script>

<style lang="scss">
.deals-title {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 10px;
}

.deals-divider {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .line {
    flex-grow: 1;
    height: 1px;
    background-color: #e7e7e7;
  }

  .pagination-dots {
    display: flex;
    margin-left: auto;

    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #e7e7e7;
      margin: 0 5px;
      cursor: pointer;
      transition: background-color 0.3s ease;

      &.active {
        background-color: #f75454;
      }
    }
  }
}

.deals-slider {
  margin-bottom: 20px;
  position: relative;
  min-height: 320px;

  .carousel {
    .carousel-inner {
      position: relative;
      min-height: 320px;
    }
  }
}

.deal-card {
  display: flex;
  margin-bottom: 20px;

  .deal-image {
    width: 200px;
    flex-shrink: 0;
    border-radius: 8px;
    overflow: hidden;

    img {
      width: 100%;
      height: auto;
      object-fit: cover;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .deal-content {
    padding: 20px 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .deal-title {
    color: #333;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    transition: color 0.3s ease;

    &:hover {
      color: #f75454;
    }
  }

  .deal-author {
    font-size: 14px;
    color: #777;
    margin-bottom: 15px;
  }

  .deal-price {
    font-size: 28px;
    font-weight: bold;
    color: #f75454;
    margin-bottom: 15px;
  }
}

@media (max-width: 991px) {
  .deal-card {
    flex-direction: column;

    .deal-image {
      // width: 100%;

      img {
        height: 100px;
      }
    }

    .deal-content {
      padding: 20px 0;
    }
  }
}
</style>
